import { render, staticRenderFns } from "./SettingsPaperworkSetList.vue?vue&type=template&id=48c711cd&"
import script from "./SettingsPaperworkSetList.vue?vue&type=script&lang=js&"
export * from "./SettingsPaperworkSetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports